

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const CHUNK_SIZE = 750 * 1024; // 750KB (Firestore limiti için güvenli boyut)

// Dosya boyutu kontrolü
export const validateFileSize = (file) => {
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(`Dosya boyutu çok büyük. Maksimum boyut: 5MB. Dosya boyutu: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
  }
  return true;
};

// Dosyayı base64'e çeviren fonksiyon
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result;
      resolve(base64);
    };
    reader.onerror = reject;
  });
};

// Dosyayı parçalara bölen fonksiyon
const splitBase64IntoChunks = (base64Data) => {
  const chunks = [];
  let index = 0;
  while (index < base64Data.length) {
    chunks.push(base64Data.slice(index, index + CHUNK_SIZE));
    index += CHUNK_SIZE;
  }
  return chunks;
};

// Ana upload fonksiyonu
export const uploadFile = async (file) => {
  try {
    // Boyut kontrolü
    validateFileSize(file);
    
    // Base64'e dönüştürme
    const base64 = await fileToBase64(file);
    
    // Base64'i parçalara böl
    const chunks = splitBase64IntoChunks(base64);
    
    return {
      name: file.name,
      size: file.size,
      type: file.type,
      data: base64,
      chunks: chunks,
      chunkCount: chunks.length,
      uploadedAt: new Date().toISOString()
    };
  } catch (error) {
    console.error('Dosya yükleme hatası:', error);
    throw error;
  }
};

// Parçaları birleştiren fonksiyon
export const mergeChunks = (chunks) => {
  return chunks.join('');
};

// Base64'ten dosya indirme için yardımcı fonksiyon
export const downloadBase64File = (fileData) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = fileData.data;
  downloadLink.download = fileData.name;
  downloadLink.click();
}; 